import React, { useState, useEffect } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
import { fmtDateTime } from '../../../utils/ruDates';
function AdminNotifications() {
  const {
    request,
    showStatus
  } = useApi();
  const [activeTab, setActiveTab] = useState('broadcasts');
  const [broadcasts, setBroadcasts] = useState([]);
  const [loadingBroadcasts, setLoadingBroadcasts] = useState(false);
  const [showCreateBroadcast, setShowCreateBroadcast] = useState(false);
  const [broadcastForm, setBroadcastForm] = useState({
    title: '',
    message: '',
    broadcast_type: 'email',
    target_type: 'all',
    target_plan: 'free',
    scheduled_at: ''
  });
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const [templateForm, setTemplateForm] = useState({
    name: '',
    template_type: 'email',
    subject: '',
    body: ''
  });
  useEffect(() => {
    if (activeTab === 'broadcasts') loadBroadcasts();
    // Шаблоны нужны на обеих вкладках: на рассылках они подставляют текст.
    loadTemplates();
  }, [activeTab]);
  const loadBroadcasts = async () => {
    setLoadingBroadcasts(true);
    try {
      const data = await request('/api/v1/admin/broadcasts');
      setBroadcasts(data || []);
    } catch (e) {
      logger.error(e);
    } finally {
      setLoadingBroadcasts(false);
    }
  };
  const loadTemplates = async () => {
    setLoadingTemplates(true);
    try {
      const data = await request('/api/v1/admin/notification-templates');
      setTemplates(data || []);
    } catch (e) {
      logger.error(e);
    } finally {
      setLoadingTemplates(false);
    }
  };
  const applyTemplate = templateId => {
    const template = templates.find(t => t.id === templateId);
    if (!template) return;
    setBroadcastForm(prev => ({
      ...prev,
      title: template.subject || template.name,
      message: template.body || ''
    }));
  };
  const handleCreateBroadcast = async e => {
    e.preventDefault();
    try {
      const {
        target_plan,
        ...rest
      } = broadcastForm;
      await request('/api/v1/admin/broadcasts', {
        method: 'POST',
        body: JSON.stringify({
          ...rest,
          target_filter: rest.target_type === 'by_plan' ? {
            plan: target_plan
          } : null
        })
      });
      showStatus('success', 'Рассылка создана');
      setShowCreateBroadcast(false);
      setBroadcastForm({
        title: '',
        message: '',
        broadcast_type: 'email',
        target_type: 'all',
        target_plan: 'free',
        scheduled_at: ''
      });
      loadBroadcasts();
    } catch (e) {
      showStatus('error', e.message || 'Не удалось создать рассылку');
    }
  };
  const handleSendBroadcast = async id => {
    if (!window.confirm('Отправить рассылку сейчас? Письма уйдут реальным пользователям.')) return;
    try {
      const result = await request(`/api/v1/admin/broadcasts/${id}/send`, {
        method: 'POST'
      });
      const failed = result.failed_count ? `, ошибок: ${result.failed_count}` : '';
      showStatus('success', `Отправлено ${result.sent_count} из ${result.recipients}${failed}`);
      loadBroadcasts();
    } catch (e) {
      showStatus('error', e.message || 'Не удалось отправить рассылку');
    }
  };
  const handleDeleteBroadcast = async id => {
    if (!window.confirm('Удалить?')) return;
    try {
      await request(`/api/v1/admin/broadcasts/${id}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Удалено');
      loadBroadcasts();
    } catch (e) {
      showStatus('error', e.message || 'Не удалось удалить рассылку');
    }
  };
  const handleCreateTemplate = async e => {
    e.preventDefault();
    try {
      await request('/api/v1/admin/notification-templates', {
        method: 'POST',
        body: JSON.stringify(templateForm)
      });
      showStatus('success', 'Шаблон создан');
      setShowCreateTemplate(false);
      setTemplateForm({
        name: '',
        template_type: 'email',
        subject: '',
        body: ''
      });
      loadTemplates();
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  const handleDeleteTemplate = async id => {
    if (!window.confirm('Удалить шаблон?')) return;
    try {
      await request(`/api/v1/admin/notification-templates/${id}`, {
        method: 'DELETE'
      });
      showStatus('success', 'Удалено');
      loadTemplates();
    } catch (e) {
      showStatus('error', 'Ошибка');
    }
  };
  const getStatusBadge = status => {
    const colors = {
      draft: '#95a5a6',
      scheduled: '#f39c12',
      sent: '#27ae60',
      cancelled: '#e74c3c'
    };
    const labels = {
      draft: 'Черновик',
      scheduled: 'Запланировано',
      sent: 'Отправлено',
      cancelled: 'Отменено'
    };
    return <span style={{
      padding: '4px 8px',
      borderRadius: '12px',
      fontSize: '12px',
      background: colors[status] || '#666',
      color: 'white'
    }}>{labels[status] || status}</span>;
  };
  const getChannelLabel = value => {
    const labels = {
      email: 'Email',
      push: 'Push',
      both: 'Email + Push'
    };
    return labels[value] || value;
  };
  const formatDate = iso => iso ? fmtDateTime(iso) : '-';
  return <div className="admin-page">
            <h1>Уведомления</h1>

            <div style={{
      display: 'flex',
      gap: '10px',
      marginBottom: '20px'
    }}>
                <button onClick={() => setActiveTab('broadcasts')} style={{
        padding: '10px 20px',
        border: 'none',
        borderRadius: '4px',
        background: activeTab === 'broadcasts' ? '#3498db' : '#e9ecef',
        color: activeTab === 'broadcasts' ? 'white' : '#333',
        cursor: 'pointer'
      }}>
                    Рассылки
                </button>
                <button onClick={() => setActiveTab('templates')} style={{
        padding: '10px 20px',
        border: 'none',
        borderRadius: '4px',
        background: activeTab === 'templates' ? '#3498db' : '#e9ecef',
        color: activeTab === 'templates' ? 'white' : '#333',
        cursor: 'pointer'
      }}>
                    Шаблоны
                </button>
            </div>

            {activeTab === 'broadcasts' && <>
                    <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '15px'
      }}>
                        <button onClick={() => setShowCreateBroadcast(!showCreateBroadcast)} style={{
          padding: '10px 20px',
          background: '#27ae60',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
                            {showCreateBroadcast ? 'Отмена' : '+ Новая рассылка'}
                        </button>
                    </div>

                    {showCreateBroadcast && <form onSubmit={handleCreateBroadcast} style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
                            {templates.length > 0 && <div style={{
          marginBottom: '15px'
        }}>
                                <label style={{
            display: 'block',
            marginBottom: '5px'
          }}>Подставить шаблон</label>
                                <select value="" onChange={e => applyTemplate(e.target.value)} style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px'
          }}>
                                    <option value="">— без шаблона —</option>
                                    {templates.filter(t => t.is_active).map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                </select>
                            </div>}
                            <div style={{
          marginBottom: '15px'
        }}>
                                <label style={{
            display: 'block',
            marginBottom: '5px'
          }}>Заголовок</label>
                                <input type="text" value={broadcastForm.title} onChange={e => setBroadcastForm({
            ...broadcastForm,
            title: e.target.value
          })} style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px'
          }} required />
                            </div>
                            <div style={{
          marginBottom: '15px'
        }}>
                                <label style={{
            display: 'block',
            marginBottom: '5px'
          }}>Сообщение</label>
                                <textarea value={broadcastForm.message} onChange={e => setBroadcastForm({
            ...broadcastForm,
            message: e.target.value
          })} style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            minHeight: '100px'
          }} required />
                            </div>
                            <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr',
          gap: '15px',
          marginBottom: '15px'
        }}>
                                <div>
                                    <label style={{
              display: 'block',
              marginBottom: '5px'
            }}>Тип</label>
                                    <select value={broadcastForm.broadcast_type} onChange={e => setBroadcastForm({
              ...broadcastForm,
              broadcast_type: e.target.value
            })} style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}>
                                        <option value="email">Email</option>
                                    </select>
                                </div>
                                <div>
                                    <label style={{
              display: 'block',
              marginBottom: '5px'
            }}>Получатели</label>
                                    <select value={broadcastForm.target_type} onChange={e => setBroadcastForm({
              ...broadcastForm,
              target_type: e.target.value
            })} style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}>
                                        <option value="all">Все пользователи</option>
                                        <option value="by_plan">По тарифу</option>
                                    </select>
                                </div>
                                {broadcastForm.target_type === 'by_plan' && <div>
                                    <label style={{
              display: 'block',
              marginBottom: '5px'
            }}>Тариф</label>
                                    <select value={broadcastForm.target_plan} onChange={e => setBroadcastForm({
              ...broadcastForm,
              target_plan: e.target.value
            })} style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}>
                                        <option value="free">Free</option>
                                        <option value="standard">Standard</option>
                                        <option value="full">Full</option>
                                    </select>
                                </div>}
                                <div>
                                    <label style={{
              display: 'block',
              marginBottom: '5px'
            }}>Запланировать</label>
                                    <input type="datetime-local" value={broadcastForm.scheduled_at} onChange={e => setBroadcastForm({
              ...broadcastForm,
              scheduled_at: e.target.value
            })} style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }} />
                                </div>
                            </div>
                            <button type="submit" style={{
          padding: '10px 20px',
          background: '#3498db',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>Создать</button>
                        </form>}

                    <div style={{
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
                        <table style={{
          width: '100%',
          borderCollapse: 'collapse'
        }}>
                            <thead style={{
            background: '#f8f9fa',
            borderBottom: '2px solid #e9ecef'
          }}>
                                <tr>
                                    <th style={{
                padding: '12px',
                textAlign: 'left'
              }}>Заголовок</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'center'
              }}>Тип</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'center'
              }}>Статус</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'center'
              }}>Отправлено</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'right'
              }}>Действия</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingBroadcasts && <tr><td colSpan="5" style={{
                padding: '20px',
                textAlign: 'center'
              }}>Загрузка...</td></tr>}
                                {!loadingBroadcasts && broadcasts.length === 0 && <tr><td colSpan="5" style={{
                padding: '20px',
                textAlign: 'center'
              }}>Нет рассылок</td></tr>}
                                {broadcasts.map(b => <tr key={b.id} style={{
              borderBottom: '1px solid #e9ecef'
            }}>
                                        <td style={{
                padding: '12px'
              }}>{b.title}</td>
                                        <td style={{
                padding: '12px',
                textAlign: 'center'
              }}>{getChannelLabel(b.broadcast_type)}</td>
                                        <td style={{
                padding: '12px',
                textAlign: 'center'
              }}>{getStatusBadge(b.status)}</td>
                                        <td style={{
                padding: '12px',
                textAlign: 'center'
              }}>{b.sent_count > 0 ? b.sent_count : '-'}</td>
                                        <td style={{
                padding: '12px',
                textAlign: 'right'
              }}>
                                            {b.status !== 'sent' && <>
                                                    <button onClick={() => handleSendBroadcast(b.id)} style={{
                    marginRight: '10px',
                    background: 'none',
                    border: 'none',
                    color: '#27ae60',
                    cursor: 'pointer'
                  }}>Отправить</button>
                                                    <button onClick={() => handleDeleteBroadcast(b.id)} style={{
                    background: 'none',
                    border: 'none',
                    color: '#e74c3c',
                    cursor: 'pointer'
                  }}>Удалить</button>
                                                </>}
                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                </>}

            {activeTab === 'templates' && <>
                    <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '15px'
      }}>
                        <button onClick={() => setShowCreateTemplate(!showCreateTemplate)} style={{
          padding: '10px 20px',
          background: '#27ae60',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
                            {showCreateTemplate ? 'Отмена' : '+ Новый шаблон'}
                        </button>
                    </div>

                    {showCreateTemplate && <form onSubmit={handleCreateTemplate} style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        marginBottom: '20px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
                            <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '15px',
          marginBottom: '15px'
        }}>
                                <div>
                                    <label style={{
              display: 'block',
              marginBottom: '5px'
            }}>Название</label>
                                    <input type="text" value={templateForm.name} onChange={e => setTemplateForm({
              ...templateForm,
              name: e.target.value
            })} style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }} required />
                                </div>
                                <div>
                                    <label style={{
              display: 'block',
              marginBottom: '5px'
            }}>Тип</label>
                                    <select value={templateForm.template_type} onChange={e => setTemplateForm({
              ...templateForm,
              template_type: e.target.value
            })} style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px'
            }}>
                                        <option value="email">Email</option>
                                    </select>
                                </div>
                            </div>
                            <div style={{
          marginBottom: '15px'
        }}>
                                <label style={{
            display: 'block',
            marginBottom: '5px'
          }}>Тема (для email)</label>
                                <input type="text" value={templateForm.subject} onChange={e => setTemplateForm({
            ...templateForm,
            subject: e.target.value
          })} style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px'
          }} />
                            </div>
                            <div style={{
          marginBottom: '15px'
        }}>
                                <label style={{
            display: 'block',
            marginBottom: '5px'
          }}>Содержимое</label>
                                <textarea value={templateForm.body} onChange={e => setTemplateForm({
            ...templateForm,
            body: e.target.value
          })} placeholder="Используйте {{user_name}}, {{company_name}} для переменных" style={{
            width: '100%',
            padding: '8px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            minHeight: '150px'
          }} required />
                            </div>
                            <button type="submit" style={{
          padding: '10px 20px',
          background: '#3498db',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>Создать</button>
                        </form>}

                    <div style={{
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        overflow: 'hidden'
      }}>
                        <table style={{
          width: '100%',
          borderCollapse: 'collapse'
        }}>
                            <thead style={{
            background: '#f8f9fa',
            borderBottom: '2px solid #e9ecef'
          }}>
                                <tr>
                                    <th style={{
                padding: '12px',
                textAlign: 'left'
              }}>Название</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'center'
              }}>Тип</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'left'
              }}>Тема</th>
                                    <th style={{
                padding: '12px',
                textAlign: 'right'
              }}>Действия</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingTemplates && <tr><td colSpan="4" style={{
                padding: '20px',
                textAlign: 'center'
              }}>Загрузка...</td></tr>}
                                {!loadingTemplates && templates.length === 0 && <tr><td colSpan="4" style={{
                padding: '20px',
                textAlign: 'center'
              }}>Нет шаблонов</td></tr>}
                                {templates.map(t => <tr key={t.id} style={{
              borderBottom: '1px solid #e9ecef'
            }}>
                                        <td style={{
                padding: '12px'
              }}>{t.name}</td>
                                        <td style={{
                padding: '12px',
                textAlign: 'center'
              }}>{getChannelLabel(t.template_type)}</td>
                                        <td style={{
                padding: '12px'
              }}>{t.subject || '-'}</td>
                                        <td style={{
                padding: '12px',
                textAlign: 'right'
              }}>
                                            <button onClick={() => handleDeleteTemplate(t.id)} style={{
                  background: 'none',
                  border: 'none',
                  color: '#e74c3c',
                  cursor: 'pointer'
                }}>Удалить</button>
                                        </td>
                                    </tr>)}
                            </tbody>
                        </table>
                    </div>
                </>}
        </div>;
}
export default AdminNotifications;
